module.exports = __webpack_public_path__ + "static/media/location-icon.d7e8225a.webp";